const SET_LOADING = 'SET_LOADING';

export { SET_LOADING };
